import React from "react"
import Select from "./Select.js"
import Error from "./Error.js"
import Warn from "./Warn.js"
import { FieldIndicator } from "../Indicators"
import styled from "styled-components"

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const SelectField = ({
  input,
  data,
  type,
  meta: { touched, error, warning, asyncValidating },
  children
}) =>
  <div>
    <Wrapper>
      <Select {...input} type={type} error={touched && error}>
        {children}
      </Select>
      {asyncValidating ? <FieldIndicator /> : ""}
    </Wrapper>
    {touched &&
      ((error &&
        <Error>
          {error}
        </Error>) ||
        (warning &&
          <Warn>
            {warning}
          </Warn>))}
  </div>

export default SelectField



// WEBPACK FOOTER //
// ./src/UI/Form/SelectField.js